<script setup>
import { computed, getCurrentInstance, watch } from 'vue';
import { useAsyncState } from '@vueuse/core';

const props = defineProps({
    contentId: Number,
    item: Object
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Async Data Fetching ---

const { state: field, execute: fetchField } = useAsyncState(
    async () => {
        // If fieldId is null (e.g. "Collection items"), we don't fetch from modulestructure
        if (!props.item.fieldId) return null;

        return store.dispatch('itemData/get', {
            tableName: 'modulestructure',
            id: props.item.fieldId
        });
    },
    null,
    { immediate: true }
);

// --- The Reactive Watcher ---
watch(
    () => props.item.fieldId,
    (newId, oldId) => {
        // Only reset operator and re-fetch if the ID actually changed
        if (newId !== oldId) {
            props.item.operator = "";
            fetchField();
        }
    }
);

// --- Computed Properties ---

const fieldType = computed(() => {
    // If fieldId is null, it's a "Collection" type filter
    if (props.item.fieldId === null) return 'collection';
    return field.value?.type;
});

const typeOptions = computed(() => {
    // If we have no type yet and it's not a collection, return empty to wait for async
    if (!fieldType.value && props.item.fieldId !== null) return [];

    const options = store.getters['collectionFilters/typesOptions'](fieldType.value, props.item.fieldId);
    return options || [];
});
</script>

<template>
    <select
        v-if="typeOptions && typeOptions.length > 0"
        v-model="item.operator"
        class="form-select form-select-sm d-inline-block w-auto"
    >
        <option selected disabled value="">Select&hellip;</option>
        <option v-for="option in typeOptions" :key="option.value" :value="option.value">
            {{ option.text }}
        </option>
    </select>
</template>